export default class ResquestUpdateCustomerProfile {
    occupation!: string;
    relationWithGovernment!: boolean;
    phoneNumberCode!: string;
    phoneNumber!: string;
    nickname!: string;
}